import { keyframes } from '@emotion/react';
const slideInFromTop = keyframes `
  0% { transform: translateY(-50%) scale(0.9); opacity: 0;}
  100% { transform: translateY(0) scale(1); opacity: 1;}
`;
const slideOutFromTop = keyframes `
  0% { transform: translateY(0) scale(1); opacity: 1;}
  100% { transform: translateY(-50%) scale(0.9); opacity: 0;}
`;
const slideInFromBottom = keyframes `
  0% { transform: translateY(50%) scale(0.9); opacity: 0;}
  100% { transform: translateY(0) scale(1); opacity: 1;}
`;
const slideOutFromBottom = keyframes `
  0% { transform: translateY(0) scale(1); opacity: 1;}
  100% { transform: translateY(50%) scale(0.9); opacity: 0;}
`;
export const getToastAnimations = (position) => {
    const isTopPosition = position === null || position === void 0 ? void 0 : position.includes('top');
    return {
        enter: isTopPosition ? slideInFromTop : slideInFromBottom,
        leave: isTopPosition ? slideOutFromTop : slideOutFromBottom,
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYW5pbWF0aW9uVXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9jb21tb25zL0Nob2NvVG9hc3QvdXRpbHMvYW5pbWF0aW9uVXRpbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLGdCQUFnQixDQUFDO0FBTTNDLE1BQU0sY0FBYyxHQUFjLFNBQVMsQ0FBQTs7O0NBRzFDLENBQUM7QUFFRixNQUFNLGVBQWUsR0FBYyxTQUFTLENBQUE7OztDQUczQyxDQUFDO0FBRUYsTUFBTSxpQkFBaUIsR0FBYyxTQUFTLENBQUE7OztDQUc3QyxDQUFDO0FBRUYsTUFBTSxrQkFBa0IsR0FBYyxTQUFTLENBQUE7OztDQUc5QyxDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0sa0JBQWtCLEdBQUcsQ0FBQyxRQUF3QixFQUFFLEVBQUU7SUFDN0QsTUFBTSxhQUFhLEdBQUcsUUFBUSxhQUFSLFFBQVEsdUJBQVIsUUFBUSxDQUFFLFFBQVEsQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUVoRCxPQUFPO1FBQ0wsS0FBSyxFQUFFLGFBQWEsQ0FBQyxDQUFDLENBQUMsY0FBYyxDQUFDLENBQUMsQ0FBQyxpQkFBaUI7UUFDekQsS0FBSyxFQUFFLGFBQWEsQ0FBQyxDQUFDLENBQUMsZUFBZSxDQUFDLENBQUMsQ0FBQyxrQkFBa0I7S0FDNUQsQ0FBQztBQUNKLENBQUMsQ0FBQyJ9